export const supplierDefaultValues = {};
